var map = {
	"./arrow-right.svg": 41841,
	"./close.svg": 11409,
	"./email.svg": 80146,
	"./loader.svg": 37593,
	"./logo.svg": 57633,
	"./question.svg": 5960,
	"./social-discord.svg": 90470,
	"./social-tg.svg": 32407,
	"./social-vk.svg": 68770,
	"./user.svg": 56602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36435;